window.CommandModule = window.CommandModule || {};
window.CommandModule.Slider = window.CommandModule.Slider || {};

window.CommandModule.Slider.Tab = (function($, Behaviors) {
    class Tab extends Behaviors.Behavior {
        static QUERY = "[data-sscmslider-tab]"

        static PARENT_QUERY = "[data-sscmslider]";
        static SLIDER_QUERY = "[data-sscmslider-contentrow]";

        constructor(...args) {
            super(...args)

            this.parent = this.elem.closest(Tab.PARENT_QUERY);
            this.slider = this.parent.querySelector(Tab.SLIDER_QUERY);
            this.$slider = $(this.slider);

            this.target = parseInt(this.elem.dataset.sscmsliderTab);

            this.elem.addEventListener("click", this.click_intent.bind(this));
            this.$slider.on("afterChange", this.slide_change_intent.bind(this));

            this.slide_change_intent(null, this.$slider.slick("getSlick"), this.$slider.slick("slickCurrentSlide"));
        }

        click_intent(e) {
            this.$slider.slick("slickGoTo", this.target);
        }

        slide_change_intent(event, slick, currentSlide) {
            if (currentSlide === this.target) {
                this.elem.classList.add("is-SSCMSlider-tab--active");
            } else {
                this.elem.classList.remove("is-SSCMSlider-tab--active");
            }
        }
    }

    Behaviors.register_behavior(Tab);

    return Tab;
}(window.jQuery, window.EVASuit.Behaviors))